module.exports = __webpack_public_path__ + "img/logo-white.674a0c9a.png";